import { Modal, Slider } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const levels = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9"
};

const StreamQualityModal = ({ id, open, handleClose, data = null, ...rest }) => {
  const { currentLevel, onQualityChange, type } = data || {};

  // 6 is the default value
  const [value, setValue] = useState();
  const onClose = () => {
    handleClose(id);
  };

  useEffect(() => {
    setValue(currentLevel ?? 2);
  }, [currentLevel]);

  return (
    <Modal
      open={open}
      onOk={() => {
        handleClose(id);
      }}
      onCancel={onClose}
      className="stream-quality"
      cancelText="Cancel"
      okText="OK"
      closable={false}
    >
      <div className="stream-quality-content">
        <div className="stream-quality-header">
          {type === "stream-quality" ? "Quality streaming" : "Compression level"}
        </div>
        <div className="stream-quality-slider">
          <p>
            {type === "stream-quality" ? "Quality Level: " : "Compression Level: "}
            <span>{value >= 5 ? "High" : "Low"}</span>
          </p>
          <Slider
            max={9}
            min={0}
            onChange={(v) => {
              setValue(v);
              onQualityChange?.(v);
            }}
            value={value}
            dots
            marks={levels}
          />
        </div>
      </div>
    </Modal>
  );
};
export default StreamQualityModal;
